import CountUp from 'react-countup'
import { useContext } from 'use-context-selector'

import { useProjectT } from 'services/ProjectLabels'

import TestGroupingContext from '../../TestGroupingContext'
import * as s from './Result.module.scss'

const Result = () => {
  const pt = useProjectT()
  const { styles, testResult, font } = useContext(TestGroupingContext)
  const totalItems = Object.values(testResult)
  const countSuccess = Object.values(testResult).filter((e) => e)

  const per = Math.round((countSuccess.length / totalItems.length) * 100)

  return (
    <div className={s.root}>
      <div className={s.count} style={font?.h4}>
        <CountUp end={countSuccess.length} /> / {totalItems.length}{' '}
        {pt('elements.testGrouping.result')}
      </div>
      <div
        className={s.progress}
        style={{ ...styles.progress, borderRadius: styles.progress.borderRadius }}
      >
        <div
          style={{
            ...styles.progressResult,
            width: `${per}%`,
            height: styles.progress.height,
          }}
        />
      </div>
    </div>
  )
}

export default Result
